import api from "../services/api";

import { IOperador, ISearchRequest, ISearchResponse } from "../interfaces";

interface IOperadorInsertResponse {
    operador: IOperador;
    message: string;
}

class OperatorRepository {

    public List = async (searchRequest: ISearchRequest): Promise<ISearchResponse<IOperador>> => {

        const response = await api.get<ISearchResponse<IOperador>>("operador", {
            params: {
                search: searchRequest.search,
                filter: searchRequest.filter,
                pagenumber: searchRequest.pageNumber,
                recordsbypage: searchRequest.recordsByPage
            }
        });

        return response.data;
    }

    public Insert = async ({ nome, senha }: IOperador): Promise<IOperadorInsertResponse> => {
        const response = await api.post<IOperadorInsertResponse>("operador", { nome, senha });

        return response.data;
    }

    // public GetById = async (id: string): Promise<IOperador> => {
    //     const response = await api.get<IOperador>(`operador/${id}`);

    //     return response.data;
    // }
}

const operatorRepository = new OperatorRepository();
export default operatorRepository;
